import { render, staticRenderFns } from "./TheOrgSelectorDialog.vue?vue&type=template&id=51120db7&"
import script from "./TheOrgSelectorDialog.vue?vue&type=script&lang=js&"
export * from "./TheOrgSelectorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports